import React from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { Box } from "@mui/material";
// import Tabs from './Tabs'
import './ourGames.css'
import OurGames from '../../components/OurGames/OurGames';

const ourGames: React.FC = () => {
  return (
    <Box className='newsBlog-page'>
      <Header />
      <Box className="ellipse11"></Box>
      <Box className="ellipse22"></Box>
      <Box className="linear"></Box>
      <Box className='hero-ourgame'></Box>
      {/* <Tabs/> */}
      <OurGames />
      <Footer />
    </Box>
  );
};

export default ourGames;